import Button from 'react-bootstrap/Button';

interface PageBaseButtonProps {
  onClick: () => void;
  variant: string;
  buttonText: string;
}

const PageBaseButton = ({
  onClick,
  variant,
  buttonText,
}: PageBaseButtonProps) => {
  return (
    <Button
      variant={variant}
      size="sm"
      className="rounded-pill px-3"
      onClick={onClick}
    >
      {buttonText}
    </Button>
  );
};

export default PageBaseButton;
